<template>
    <div style="display: flex; align-items: center; grid-gap: 4px;">
        <TText value="From" :color="getColor(color)" small />

        <TTimePicker
          :style="`color: ${getColor(color)};`"
          :max_time="time_range.start + time_range.duration"
          :min_value="limit_time_range? limit_time_range.start : 4000"
          :value="time_range.start"
          @change="setStart($event)"
        />

        <TText value="to" :color="getColor(color)" small />

        <TTimePicker
          :style="`color: ${getColor(color)};`"
          :min_time="time_range.start"
          :max_time="limit_time_range ? limit_time_range.start + limit_time_range.duration : 86340"
          :value="time_range.start + time_range.duration"
          @change="setEnd($event)"
        />
    </div>
</template>

<script>
import TTimePicker from '../Taktify/TTimePicker.component.vue';
import { TColor } from '@/mixins/TColor.mixin.js';

  export default {
    components: {
      TTimePicker
    },

    props: [
      'time_range',
      'color',
      'limit_time_range',
      'limit_time_rangei'
    ],

    mixins: [
      TColor,
    ],

    data: () => ({
    //   time_range: {
    //     start: 0,
    //     duration: 86400
    //   }
    }),

    methods: {
      setStart(timestamp){
        let end = this.time_range.duration + this.time_range.start
        this.time_range.start = timestamp;
        this.setEnd(end)
      },
      setEnd(timestamp){
        this.time_range.duration = timestamp - this.time_range.start
        this.$emit('change', this.time_range)
      }
    }
  }
</script>
